import { ONBOARDING_LINK_STORE_STEPS } from '~/constants/auth'
import {
  DEFAULT_CALENDAR_VIEW,
  DEFAULT_FILTER_VIEW,
  DEFAULT_MANUALLY_TIMEZONE,
  DEFAULT_PAGE_SIZE,
  DEFAULT_TIMEZONE_SETTING,
  DEFAULT_PRINTING_SIZE,
} from '~/constants/settings'
import { isStoreImportFailed } from './store'
import { STORE_TYPES } from '~/constants/store'

export const getStoreType = (url) => {
  if (url.contains(ONBOARDING_LINK_STORE_STEPS.CATEGORY))
    return ONBOARDING_LINK_STORE_STEPS.CATEGORY
  if (url.contains(ONBOARDING_LINK_STORE_STEPS.VERIFICATION))
    return ONBOARDING_LINK_STORE_STEPS.VERIFICATION
  return ONBOARDING_LINK_STORE_STEPS.GENERAL
}

// TODO: Need optimize the below function with function convertStoreListOptions()
export const convertTopbarStoreOptions = (
  organizations,
  stores,
  mapUserStores = {},
) =>
  (organizations || []).reduce((values, org) => {
    const childrenStores = (stores || [])
      .filter((s) => s.orgId === org.id)
      .filter((s) => !isStoreImportFailed(mapUserStores[s.storeId]))
      .map((s) => ({
        ...s,
        value: s.storeId,
        label: `${s.storeName}${!s.syncCompleted ? ' (Syncing...)' : ''}`,
      }))

    if (childrenStores.length === 0) return values

    values.push({ value: org.id, label: org.name, title: true })
    return values.concat(childrenStores)
  }, [])

export const convertStoreListOptions = (organizations, stores) =>
  (organizations || []).reduce((values, org) => {
    const childrenStores = (stores || [])
      .filter((s) => s.orgId === org.id)
      .map((s) => ({
        ...s,
        value: s.storeId,
        label: s.storeName,
      }))

    if (childrenStores.length === 0) return values

    values.push({
      value: org.id,
      label: org.name,
      title: true,
      isGroup: true,
    })
    return values.concat(childrenStores)
  }, [])

// eslint-disable-next-line
export const convertLocationListOptions = (
  organizations,
  stores,
  locations,
) => {
  const listStore = (organizations || []).reduce((values, org) => {
    let childrenStores = (stores || [])
      .filter((s) => s.orgId === org.id)
      .map((s) => ({
        ...s,
        value: s.storeId,
        label: s.storeName,
        locationRoles:
          org?.assignedStoresData?.find((st) => st.store_id === s.storeId)
            ?.location_roles || [],
        customRoles:
          org?.assignedStoresData?.find((st) => st.store_id === s.storeId)
            ?.custom_roles || {},
      }))

    const isAdmin = org?.role?.isOwner || org?.role?.isGa

    if (childrenStores?.some((s) => s.storeType === STORE_TYPES.GREENLINE)) {
      const store = childrenStores[0]
      const warehouses = locations?.find((o) => o._id === store.orgId)
        ?.stores?.[0]?.warehouses
      childrenStores = (warehouses || [])
        ?.map((w) => ({
          ...w,
          storeType: STORE_TYPES.GREENLINE,
          value: w.location_id,
          label: w.name,
        }))
        .sort((a, b) => a.label.localeCompare(b.label))

      const displayAllLocation =
        isAdmin ||
        !!(
          store?.locationRoles &&
          (store?.locationRoles?.length === 0 ||
            !store?.locationRoles?.some((l) => !l?.enabled))
        )

      if (displayAllLocation) {
        childrenStores.unshift({
          value: `all_${store?.storeId}`,
          label: 'All Locations',
          store_id: store?.storeId,
          organization_id: store?.orgId,
          storeType: STORE_TYPES.GREENLINE,
        })
      }
    }
    if (childrenStores?.some((s) => s.storeType === STORE_TYPES.COVA)) {
      const store = childrenStores[0]
      const warehouses = locations?.find((o) => o._id === store.orgId)
        ?.stores?.[0]?.warehouses
      childrenStores = (warehouses || [])
        ?.map((w) => ({
          ...w,
          storeType: STORE_TYPES.COVA,
          value: w?.cova_metadata?.LocationId,
          label: w.name,
        }))
        .sort((a, b) => a.label.localeCompare(b.label))

      const displayAllLocation =
        isAdmin ||
        !!(
          store?.locationRoles &&
          (store?.locationRoles?.length === 0 ||
            !store?.locationRoles?.some((l) => !l?.enabled))
        )

      if (displayAllLocation) {
        childrenStores.unshift({
          value: `all_${store?.storeId}`,
          label: 'All Locations',
          store_id: store?.storeId,
          organization_id: store?.orgId,
          storeType: STORE_TYPES.COVA,
        })
      }
    }
    if (childrenStores?.some((s) => s.storeType === STORE_TYPES.FLOWHUB)) {
      const store = childrenStores[0]
      const warehouses = locations?.find((o) => o._id === store.orgId)
        ?.stores?.[0]?.warehouses
      childrenStores = (warehouses || [])
        ?.map((w) => ({
          ...w,
          storeType: STORE_TYPES.FLOWHUB,
          value: w?.location_id,
          label: w.name,
        }))
        .sort((a, b) => a.label.localeCompare(b.label))

      const displayAllLocation =
        isAdmin ||
        !!(
          store?.locationRoles &&
          (store?.locationRoles?.length === 0 ||
            !store?.locationRoles?.some((l) => !l?.enabled))
        )

      if (displayAllLocation) {
        childrenStores.unshift({
          value: `all_${store?.storeId}`,
          label: 'All Locations',
          store_id: store?.storeId,
          organization_id: store?.orgId,
          storeType: STORE_TYPES.FLOWHUB,
        })
      }
    }
    if (childrenStores?.some((s) => s.storeType === STORE_TYPES.LIGHTSPEED)) {
      const store = childrenStores[0]
      const warehouses = locations?.find((o) => o._id === store.orgId)
        ?.stores?.[0]?.warehouses
      childrenStores = (warehouses || [])
        ?.map((w) => ({
          ...w,
          storeType: STORE_TYPES.LIGHTSPEED,
          value: w?.location_id,
          label: w.name,
        }))
        .sort((a, b) => a.label.localeCompare(b.label))

      const displayAllLocation =
        isAdmin ||
        !!(
          store?.locationRoles &&
          (store?.locationRoles?.length === 0 ||
            !store?.locationRoles?.some((l) => !l?.enabled))
        )

      if (displayAllLocation) {
        childrenStores.unshift({
          value: `all_${store?.storeId}`,
          label: 'All Locations',
          store_id: store?.storeId,
          organization_id: store?.orgId,
          storeType: STORE_TYPES.LIGHTSPEED,
        })
      }
    }
    if (childrenStores.length === 0) return values
    values.push({
      value: org.id,
      label: org.name,
      title: true,
      isGroup: true,
    })
    return values.concat(childrenStores)
  }, [])

  return listStore
}

export const mapSettingData = ({
  user_settings,
  default_org: init_default_org,
  default_store: init_default_store,
  default_location: init_default_location,
}) => {
  const default_user_settings = {
    default_org: init_default_org,
    default_store: init_default_store,
    default_location: init_default_location,
    filters: DEFAULT_FILTER_VIEW,
    list_pagination: DEFAULT_PAGE_SIZE,
    product_view: '',
    calendar_view: DEFAULT_CALENDAR_VIEW,
    printing_size: DEFAULT_PRINTING_SIZE,
    tz_setting: DEFAULT_TIMEZONE_SETTING,
    tz_timezone: DEFAULT_MANUALLY_TIMEZONE,
  }
  if (user_settings) {
    if (user_settings?.general_settings) {
      const {
        default_org = init_default_org,
        default_store = init_default_store,
        default_location = init_default_location,
        tutorial_dismissed = false,
      } = user_settings?.general_settings
      default_user_settings.default_org = default_org
      default_user_settings.default_store = default_store
      default_user_settings.default_location = default_location
      default_user_settings.tutorial_dismissed = tutorial_dismissed
    }

    if (user_settings?.store_settings) {
      const [
        {
          display_settings: {
            filters = DEFAULT_FILTER_VIEW,
            list_pagination = DEFAULT_PAGE_SIZE,
            product_view = '',
          },
          fulfillment_settings: {
            calendar_view = DEFAULT_CALENDAR_VIEW,
            printing_size = DEFAULT_PRINTING_SIZE,
          },
          timezone_settings: {
            setting: tz_setting = DEFAULT_TIMEZONE_SETTING,
            timezone: tz_timezone = DEFAULT_MANUALLY_TIMEZONE,
          },
        },
      ] = user_settings?.store_settings
      default_user_settings.filters = filters
      default_user_settings.list_pagination = list_pagination
      default_user_settings.product_view = product_view
      default_user_settings.calendar_view = calendar_view
      default_user_settings.printing_size = printing_size
      default_user_settings.tz_setting = tz_setting
      default_user_settings.tz_timezone = tz_timezone
    }
  }
  return default_user_settings
}

export const mapUserData = (data) => ({
  user_settings: mapSettingData(data),
})

export const mapUpdateSettingData = ({
  default_org,
  default_store,
  filters,
  list_pagination,
  product_view,
  calendar_view,
  printing_size,
  tz_setting,
  tz_timezone,
}) => ({
  general_settings: { default_org, default_store },
  store_settings: {
    display_settings: {
      filters,
      list_pagination,
      product_view,
    },
    fulfillment_settings: {
      calendar_view,
      printing_size,
    },
    timezone_settings: {
      setting: tz_setting,
      timezone: tz_timezone,
    },
    store_id: '',
  },
})

export const mapOrganizationData = ({
  organization_name,
  organization_id,
  _created,
  profile_type,
  enabled_ticket_system,
  cf_org_id,
  cs_ws_id,
}) => ({
  organization_name,
  organization_id,
  _created,
  profile_type,
  enabled_ticket_system,
  cf_org_id,
  cs_ws_id,
})
